import { render, staticRenderFns } from "./survey-btn.vue?vue&type=template&id=a277efa0&scoped=true&"
import script from "./survey-btn.vue?vue&type=script&lang=js&"
export * from "./survey-btn.vue?vue&type=script&lang=js&"
import style0 from "./survey-btn.vue?vue&type=style&index=0&id=a277efa0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a277efa0",
  null
  
)

export default component.exports